import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/AuthContext';
import Layout from './components/Layout';
import Dashboard from './components/Dashboard';
import Payments from './components/Payments';
import Pharmacies from './components/Pharmacies';
import Medicines from './components/Medicines';
import Contacts from './components/Contacts';
import Staff from './components/Staff';
import Login from './components/Login';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="payments" element={<Payments />} />
            <Route path="pharmacies" element={<Pharmacies />} />
            <Route path="medicines" element={<Medicines />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="staff" element={<Staff />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
